export default {
  init() {

  },
  finalize() {
    // CF7 field "hooks"
    const $detailsField = $('textarea[name="field-business-aims"]');
    const $submitButton = $('input.wpcf7-submit');
    const $responseDiv = $('.wpcf7-response-output');

    if ($detailsField.length > 0 && $submitButton.length > 0 & $responseDiv.length > 0) {
      var responseObserver = new MutationObserver(function () {
        $('.cf7-response-message').html($responseDiv.html());
        $('#application-submit').prop('disabled', false);
      });

      responseObserver.observe($responseDiv.get()[0], { attributes: true, childList: true, characterData: true });

      $('#organisation-aims-visible').attr('placeholder', $detailsField.attr('placeholder'));

      $('#organisation-aims-visible').on('keydown keyup', function () {
        $detailsField.html($(this).val());
      });

      $('#application-submit').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $submitButton.trigger('click');
        $(this).prop('disabled', true);
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/template-corporate-membership.js